export default {
  // 停车费管理页面
  'pages.parking-fee.title': '停车费',
  'pages.parking-fee.subtitle': '管理小区停车费账单的生成、缴费和查询',
  'pages.parking-fee.currentSelection': '当前选择：',
  'pages.parking-fee.batchCreate': '批量生成',
  'pages.parking-fee.tabOther': '其他',
  'pages.parking-fee.treeTitle': '楼栋楼层房屋选择',
  'pages.parking-fee.batchCreateModal.title': '批量生成停车费账单',
  'pages.parking-fee.batchCreateModal.confirm': '确认生成',
  'pages.parking-fee.batchCreateModal.cancel': '取消',
  'pages.parking-fee.batchCreateModal.selectPeriod': '选择账期：',
  'pages.parking-fee.batchCreateModal.periodPlaceholder': '请选择账期',
  'pages.parking-fee.batchCreateModal.confirmTitle': '确认批量生成',
  'pages.parking-fee.batchCreateModal.confirmContent': '确定要批量生成 {period} 的停车费账单吗？',
  'pages.parking-fee.batchCreateModal.success': '成功生成 {count} 条账单',
  'pages.parking-fee.batchCreateModal.failed': '批量生成失败',
  'pages.parking-fee.batchCreateModal.retry': '批量生成失败，请重试',
  'pages.parking-fee.batchCreateModal.selectPeriodWarning': '请选择账期',
  'pages.parking-fee.batchCreateModal.hint': '💡 提示：批量生成将为所有未生成账单的房屋创建指定账期的停车费账单',
  'pages.parking-fee.batchCreateModal.hint2': '已存在的账单将不会重复生成',

  // 停车费表格页面
  'pages.parking-fee.table.title': '停车费账单列表',
  'pages.parking-fee.table.create': '新建账单',
  'pages.parking-fee.table.submitAudit': '提交审核',
  'pages.parking-fee.table.batchDelete': '批量删除',
  'pages.parking-fee.table.confirmDelete': '确定要删除这条记录吗？',
  'pages.parking-fee.table.confirmDeleteSelected': '确定要删除选中的 {count} 条记录吗？',
  'pages.parking-fee.table.deleteSuccess': '删除成功',
  'pages.parking-fee.table.deleteFailed': '删除失败',
  'pages.parking-fee.table.batchDeleteSuccess': '批量删除成功',
  'pages.parking-fee.table.batchDeleteFailed': '批量删除失败',
  'pages.parking-fee.table.batchDeleteDraftOnly': '批量删除仅支持草稿状态的账单',
  'pages.parking-fee.table.selectWarning': '请选择要删除的记录',
  'pages.parking-fee.table.selectAuditWarning': '请选择要提交审核的账单',
  'pages.parking-fee.table.submitAuditSuccess': '提交审核成功',
  'pages.parking-fee.table.submitAuditFailed': '提交审核失败',
  'pages.parking-fee.table.auditNamePlaceholder': '请输入审核名称',
  'pages.parking-fee.table.auditNameRequired': '请输入审核名称',
  'pages.parking-fee.table.submitRemarkPlaceholder': '请输入提交说明（可选）',
  'pages.parking-fee.table.selectedBillsTitle': '选中的账单列表（共 {count} 条）',

  // 表格列标题
  'pages.parking-fee.table.columns.houseNumber': '房号',
  'pages.parking-fee.table.columns.parkingInfo': '车位信息',
  'pages.parking-fee.table.columns.period': '账期',
  'pages.parking-fee.table.columns.billNumber': '账单编号',
  'pages.parking-fee.table.columns.ownerPhone': '业主手机',
  'pages.parking-fee.table.columns.ownerIdCard': '业主身份证',
  'pages.parking-fee.table.columns.ownerEmail': '业主邮箱',
  'pages.parking-fee.table.columns.finalAmount': '最终应付金额',
  'pages.parking-fee.table.columns.paymentAmount': '缴费金额',
  'pages.parking-fee.table.columns.dueAmount': '应缴',
  'pages.parking-fee.table.columns.actualAmount': '实缴',
  'pages.parking-fee.table.columns.auditStatus': '审核状态',
  'pages.parking-fee.table.columns.paymentStatus': '缴费状态',
  'pages.parking-fee.table.columns.paymentTime': '缴费时间',
  'pages.parking-fee.table.columns.dueDate': '到期日期',
  'pages.parking-fee.table.columns.operations': '操作',
  'pages.parking-fee.table.columns.totalAmount': '总金额',

  // 操作按钮
  'pages.parking-fee.table.actions.view': '查看',
  'pages.parking-fee.table.actions.edit': '编辑',
  'pages.parking-fee.table.actions.delete': '删除',
  'pages.parking-fee.table.actions.confirm': '确定',
  'pages.parking-fee.table.actions.cancel': '取消',

  // 审核状态
  'pages.parking-fee.table.auditStatus.draft': '草稿',
  'pages.parking-fee.table.auditStatus.pending': '待审核',
  'pages.parking-fee.table.auditStatus.approved': '已通过',
  'pages.parking-fee.table.auditStatus.rejected': '已拒绝',
  'pages.parking-fee.table.auditStatus.notified': '已通知',
  'pages.parking-fee.table.auditStatus.overdue': '逾期',
  'pages.parking-fee.table.auditStatus.cancelled': '已取消',

  // 缴费状态
  'pages.parking-fee.table.paymentStatus.unpaid': '未缴费',
  'pages.parking-fee.table.paymentStatus.paid': '已缴费',
  'pages.parking-fee.table.paymentStatus.overdue': '逾期',
  'pages.parking-fee.table.paymentStatus.partial': '部分缴费',
  'pages.parking-fee.table.paymentStatus.cancelled': '已取消',

  // 详情弹窗
  'pages.parking-fee.table.detail.title': '停车费账单详情',
  'pages.parking-fee.table.detail.close': '关闭',
  'pages.parking-fee.table.detail.basicInfo': '基本信息',
  'pages.parking-fee.table.detail.parkingOwnerInfo': '车位与业主信息',
  'pages.parking-fee.table.detail.amountInfo': '金额信息',
  'pages.parking-fee.table.detail.paymentInfo': '缴费信息',
  'pages.parking-fee.table.detail.systemInfo': '系统信息',
  'pages.parking-fee.table.detail.auditRecords': '审核记录',
  'pages.parking-fee.table.detail.loading': '加载中...',
  'pages.parking-fee.table.detail.noRecords': '暂无审核记录',

  // ParkingFeeForm 表单
  'pages.parking-fee.form.editTitle': '编辑停车费账单',
  'pages.parking-fee.form.createTitle': '新建停车费账单',
  'pages.parking-fee.form.basicInfo': '基本信息',
  'pages.parking-fee.form.houseOwnerInfo': '房屋与业主信息',
  'pages.parking-fee.form.feeInfo': '费用信息',
  'pages.parking-fee.form.remarks': '备注信息',

  // 表单字段标签
  'pages.parking-fee.form.fields.billNo': '账单编号',
  'pages.parking-fee.form.fields.status': '缴费状态',
  'pages.parking-fee.form.fields.period': '账期',
  'pages.parking-fee.form.fields.startDate': '开始时间',
  'pages.parking-fee.form.fields.endDate': '结束时间',
  'pages.parking-fee.form.fields.building': '楼栋',
  'pages.parking-fee.form.fields.floor': '楼层',
  'pages.parking-fee.form.fields.house': '房屋',
  'pages.parking-fee.form.fields.parkingInfo': '停车位信息',
  'pages.parking-fee.form.fields.parkingFee': '停车费金额',
  'pages.parking-fee.form.fields.lateFee': '滞纳金',
  'pages.parking-fee.form.fields.discountAmount': '优惠金额',
  'pages.parking-fee.form.fields.finalAmount': '最终应付金额',
  'pages.parking-fee.form.fields.remarks': '备注',

  // 表单验证消息
  'pages.parking-fee.form.validation.billNoRequired': '请输入账单编号',
  'pages.parking-fee.form.validation.statusRequired': '请选择缴费状态',
  'pages.parking-fee.form.validation.periodRequired': '请输入账期',
  'pages.parking-fee.form.validation.startDateRequired': '请选择开始时间',
  'pages.parking-fee.form.validation.endDateRequired': '请选择结束时间',
  'pages.parking-fee.form.validation.buildingRequired': '请选择楼栋',
  'pages.parking-fee.form.validation.floorRequired': '请选择楼层',
  'pages.parking-fee.form.validation.houseRequired': '请选择房屋',
  'pages.parking-fee.form.validation.parkingFeeRequired': '请输入停车费金额',
  'pages.parking-fee.form.validation.finalAmountRequired': '最终金额将自动计算',
  'pages.parking-fee.form.validation.remarksMaxLength': '备注长度不能超过500个字符',

  // 表单占位符
  'pages.parking-fee.form.placeholder.billNo': '请输入账单编号',
  'pages.parking-fee.form.placeholder.period': '如：2024-01',
  'pages.parking-fee.form.placeholder.startDate': '请选择开始时间',
  'pages.parking-fee.form.placeholder.endDate': '请选择结束时间',
  'pages.parking-fee.form.placeholder.building': '请选择楼栋',
  'pages.parking-fee.form.placeholder.floor': '请选择楼层',
  'pages.parking-fee.form.placeholder.house': '请选择房屋',
  'pages.parking-fee.form.placeholder.parkingFee': '请输入停车费金额',
  'pages.parking-fee.form.placeholder.lateFee': '请输入滞纳金',
  'pages.parking-fee.form.placeholder.discountAmount': '请输入优惠金额',
  'pages.parking-fee.form.placeholder.finalAmount': '自动计算',
  'pages.parking-fee.form.placeholder.remarks': '请输入备注信息',

  // 表单消息和错误
  'pages.parking-fee.form.message.houseNotOpenService': '该房屋没有开通停车费服务',
  'pages.parking-fee.form.message.loadConfigFailed': '加载停车费价格配置失败',
  'pages.parking-fee.form.message.houseNotBindParking': '该房屋未绑定停车位',
  'pages.parking-fee.form.message.parkingInfoNotFound': '查询不到该房屋的停车位信息',
  'pages.parking-fee.form.message.updateSuccess': '更新成功',
  'pages.parking-fee.form.message.createSuccess': '创建成功',

  // 详情弹窗标签
  'pages.parking-fee.table.detail.labels.billNo': '账单编号',
  'pages.parking-fee.table.detail.labels.period': '账期',
  'pages.parking-fee.table.detail.labels.paymentStatus': '缴费状态',
  'pages.parking-fee.table.detail.labels.auditStatus': '审核状态',
  'pages.parking-fee.table.detail.labels.startDate': '开始日期',
  'pages.parking-fee.table.detail.labels.endDate': '结束日期',
  'pages.parking-fee.table.detail.labels.parkingInfo': '车位信息',
  'pages.parking-fee.table.detail.labels.ownerInfo': '业主信息',
  'pages.parking-fee.table.detail.labels.parkingFee': '停车费金额',
  'pages.parking-fee.table.detail.labels.lateFee': '滞纳金',
  'pages.parking-fee.table.detail.labels.discountAmount': '优惠金额',
  'pages.parking-fee.table.detail.labels.finalAmount': '最终金额',
  'pages.parking-fee.table.detail.labels.paymentMethod': '支付方式',
  'pages.parking-fee.table.detail.labels.paymentReference': '支付凭证号',
  'pages.parking-fee.table.detail.labels.paymentDate': '缴费日期',
  'pages.parking-fee.table.detail.labels.createTime': '创建时间',
  'pages.parking-fee.table.detail.labels.updateTime': '更新时间',
  'pages.parking-fee.table.detail.labels.remark': '备注',
  'pages.parking-fee.table.detail.labels.ownerId': '业主ID',
  'pages.parking-fee.table.detail.labels.idCard': '身份证',
  'pages.parking-fee.table.detail.labels.email': '邮箱',

  // 提交审核弹窗
  'pages.parking-fee.table.auditModal.title': '提交审核',
  'pages.parking-fee.table.auditModal.submit': '提交审核',
  'pages.parking-fee.table.auditModal.auditName': '审核名称',
  'pages.parking-fee.table.auditModal.submitRemark': '提交说明',

  // 提交审核表格列标题
  'pages.parking-fee.table.auditModal.columns.billNo': '账单编号',
  'pages.parking-fee.table.auditModal.columns.parkingInfo': '车位信息',
  'pages.parking-fee.table.auditModal.columns.period': '账期',
  'pages.parking-fee.table.auditModal.columns.totalAmount': '总金额',
  'pages.parking-fee.table.auditModal.columns.paymentStatus': '缴费状态',

  // 面包屑导航
  'pages.breadcrumb.chargeManagement': '收费管理',
  'pages.breadcrumb.parkingFee': '停车费',

  // 货币单位
  'pages.parking-fee.currency.php': '₱',

  // Detail组件字段
  'pages.parking-fee.detail.basicInfo': '基本信息',
  'pages.parking-fee.detail.billNo': '账单编号',
  'pages.parking-fee.detail.period': '账期',
  'pages.parking-fee.detail.paymentStatus': '缴费状态',
  'pages.parking-fee.detail.approvalStatus': '审核状态',
  'pages.parking-fee.detail.startDate': '开始日期',
  'pages.parking-fee.detail.endDate': '结束日期',
  'pages.parking-fee.detail.parkingOwnerInfo': '车位与业主信息',
  'pages.parking-fee.detail.parkingInfo': '车位信息',
  'pages.parking-fee.detail.houseInfo': '关联房屋',
  'pages.parking-fee.detail.ownerInfo': '业主信息',
  'pages.parking-fee.detail.amountInfo': '金额信息',
  'pages.parking-fee.detail.baseAmount': '基础金额',
  'pages.parking-fee.detail.lateFee': '滞纳金',
  'pages.parking-fee.detail.discountAmount': '优惠金额',
  'pages.parking-fee.detail.finalAmount': '最终金额',
  'pages.parking-fee.detail.paymentInfo': '缴费信息',
  'pages.parking-fee.detail.paymentMethod': '支付方式',
  'pages.parking-fee.detail.paymentReference': '支付凭证号',
  'pages.parking-fee.detail.dueDate': '到期日期',
  'pages.parking-fee.detail.paymentDate': '缴费日期',
  'pages.parking-fee.detail.systemInfo': '系统信息',
  'pages.parking-fee.detail.createdTime': '创建时间',
  'pages.parking-fee.detail.updatedTime': '更新时间',
  'pages.parking-fee.detail.remarks': '备注',
};
